import React from 'react';
import { Modal, Text, breakpoints, Link, Title } from 'components';
import { VerticalSpace } from '@brokerbay/design-components';
import { UPGRADE_EMAIL } from 'utils';
import {
  StyledAlert,
  StyledButton,
  StyledCard,
  StyledIncludeListItem,
  StyledIncludesText,
  StyledList,
  StyledListIcon,
  StyledPerAgentText,
  StyledPrice,
} from '../constants';

type SelectPlanModalProps = {
  closeModal: () => void;
  perAgentPrice: number;
  onOk: () => void;
};

const SelectPlanModal: React.FC<SelectPlanModalProps> = ({
  closeModal,
  perAgentPrice,
  onOk,
}) => (
    <Modal
      open
      title="Select Plan"
      footer={false}
      centered
      width={breakpoints.sm}
      onCancel={closeModal}
      destroyOnClose
    >
      <VerticalSpace size={8}>
        <Title level={2}>Upgrade to a Brokerage Plan</Title>
        <Text block type="secondary">
          Upgrade to the Brokerage Plan to give your agents and staff access to
          BrokerBay&apos;s full front-desk showing system and other premium
          features.
        </Text>
        <StyledAlert
          type="info"
          banner
          message={
            <Text>
              Have any questions about your subscription? Contact customer
              support at
              <Link href={`mailto:${UPGRADE_EMAIL}`}> {UPGRADE_EMAIL}</Link>
            </Text>
          }
        />
        <StyledCard type="primary">
          <Text block textAlign="center" type="secondary" strong>
            Brokerage
          </Text>
          <StyledPrice block strong textAlign="center" data-cy="plan-price">
            ${perAgentPrice}
          </StyledPrice>
          <StyledPerAgentText block textAlign="center">
            per agent / month
          </StyledPerAgentText>
          <StyledIncludesText block strong textAlign="center">
            Includes
          </StyledIncludesText>
          <StyledList size={1}>
            <StyledIncludeListItem>
              <StyledListIcon type="antdPlusOutlined" color="blue6" />{' '}
              Everything on the Agent Plan, plus:
            </StyledIncludeListItem>
            <StyledIncludeListItem>
              <StyledListIcon type="antdCheckOutlined" color="blue6" /> Complete
              brokerage showing system
            </StyledIncludeListItem>
            <StyledIncludeListItem>
              <StyledListIcon type="antdCheckOutlined" color="blue6" /> Access
              to BrokerBay&apos;s cross-brokerage intranet
            </StyledIncludeListItem>
            <StyledIncludeListItem>
              <StyledListIcon type="antdCheckOutlined" color="blue6" />{' '}
              Interactive 3D virtual showings
            </StyledIncludeListItem>
            <StyledIncludeListItem>
              <StyledListIcon type="antdCheckOutlined" color="blue6" /> Full
              suite of administrative management tools
            </StyledIncludeListItem>
          </StyledList>
          <StyledButton
            type="primary"
            onClick={onOk}
            data-cy="upgrade-plan-button"
          >
            Upgrade
          </StyledButton>
        </StyledCard>
      </VerticalSpace>
    </Modal>
  );

export default SelectPlanModal;
